import type { BackofficeTranslations } from './backoffice.interface';

export const backofficeTranslations: BackofficeTranslations = {
  nav_section_title: 'Consola interna',
  nav_overview: 'Resumen',
  nav_organizations: 'Organizaciones',
  nav_users: 'Usuarios',
  nav_cards_cases: 'Reconciliación',
  nav_cards_calls: 'Llamadas al proveedor',

  error_generic: 'No pudimos completar la acción.',
  retry: 'Reintentar',
  filters_label: 'Filtros',
  filters_clear: 'Limpiar filtros',
  never: 'Nunca',
  actions_label: 'Acciones',

  overview_title: 'Resumen',
  overview_subtitle: 'Cómo va {{brand}} hoy, en todas sus organizaciones.',
  kpi_organizations: 'Organizaciones',
  kpi_users: 'Usuarios clientes',
  kpi_internal_users: 'Usuarios internos',
  kpi_signups_7: 'Registros · 7 días',
  kpi_signups_30: 'Registros · 30 días',
  subscriptions_title: 'Suscripciones por estado',
  subscriptions_empty: 'Aún no hay suscripciones.',
  generated_at: 'Calculado el {{date}}',
  analytics_soon_badge: 'Próximamente',
  analytics_soon_title: 'Analítica de producto',
  analytics_soon_description:
    'Embudos, retención y uso por organización, desde PostHog. Esta vista es la base para conectarlos.',

  subscription_status_active: 'Activa',
  subscription_status_trialing: 'En prueba',
  subscription_status_past_due: 'Pago pendiente',
  subscription_status_cancelled: 'Cancelada',

  status_active: 'Activa',
  status_disabled: 'Deshabilitada',

  orgs_title: 'Organizaciones',
  orgs_subtitle: 'Todas las organizaciones de {{brand}}.',
  orgs_search_placeholder: 'Buscar por correo o nombre de un miembro',
  filter_status_label: 'Estado',
  filter_status_all: 'Todos los estados',
  col_owner: 'Titular',
  col_status: 'Estado',
  col_members: 'Miembros',
  col_subscription: 'Suscripción',
  col_created: 'Creada',
  no_subscription: 'Sin suscripción',
  owner_unknown: 'Sin miembros',
  orgs_empty_title: 'No hay organizaciones',
  orgs_empty_description: 'Prueba con otra búsqueda o limpia los filtros.',

  org_detail_title: 'Organización',
  org_members_title: 'Miembros',
  org_field_id: 'ID',
  org_field_created: 'Creada',
  org_field_status: 'Estado',
  org_field_plan: 'Plan',
  org_field_period_end: 'Fin del periodo',
  org_field_trial_end: 'Fin de la prueba',
  org_field_members: 'Miembros',

  users_title: 'Usuarios',
  users_subtitle: 'Todas las cuentas de {{brand}}, clientes e internas.',
  users_search_placeholder: 'Buscar por correo o nombre',
  filter_type_label: 'Tipo',
  filter_type_all: 'Todos los tipos',
  type_user: 'Cliente',
  type_internal_user: 'Interno',
  col_user: 'Usuario',
  col_type: 'Tipo',
  col_organization: 'Organización',
  col_last_login: 'Último acceso',
  users_empty_title: 'No hay usuarios',
  users_empty_description: 'Prueba con otra búsqueda o limpia los filtros.',

  action_impersonate: 'Entrar como este usuario',
  action_promote: 'Hacer interno',
  action_view_organization: 'Ver organización',

  impersonate_title: 'Entrar como {{email}}',
  impersonate_description:
    'Este enlace abre una sesión en la cuenta del cliente. Sirve una sola vez y queda registrado quién lo abrió.',
  impersonate_link_label: 'Enlace de acceso',
  impersonate_copy: 'Copiar enlace',
  impersonate_copied: 'Copiado',
  impersonate_expires: 'Vence a las {{time}}.',
  impersonate_private_hint:
    'Ábrelo en una ventana privada: en esta misma ventana reemplazaría tu sesión interna.',
  impersonate_close: 'Cerrar',

  promote_title: '¿Hacer interno a {{email}}?',
  promote_description:
    'Saldrá de su organización, se cerrarán todas sus sesiones y la próxima vez que entre verá esta consola. No se puede deshacer desde aquí.',
  promote_confirm: 'Hacer interno',
  promote_cancel: 'Cancelar',
  promote_success: 'Ahora es un usuario interno.',

  error_LAST_ACTIVE_MEMBER:
    'Es el único miembro activo de su organización: quedaría sin nadie que pueda entrar. Crea una cuenta interna nueva.',
  error_ALREADY_INTERNAL: 'Esta cuenta ya es interna.',
  error_USER_INACTIVE: 'La cuenta está deshabilitada.',
  error_TARGET_NOT_CUSTOMER: 'Solo se puede entrar a cuentas de clientes.',

  cases_title: 'Reconciliación',
  cases_subtitle: 'Diferencias entre nuestro libro y el proveedor que alguien tiene que revisar.',
  filter_case_status_label: 'Estado',
  filter_case_status_all: 'Todos los estados',
  case_status_open: 'Abierto',
  case_status_investigating: 'En revisión',
  case_status_resolved: 'Resuelto',
  case_status_dismissed: 'Descartado',
  case_kind_balance_mismatch: 'Saldo distinto',
  case_kind_negative_balance: 'Saldo negativo',
  case_kind_transfer_stuck: 'Transferencia atascada',
  case_kind_unknown_event: 'Evento desconocido',
  case_kind_provider_account_missing: 'Cuenta ausente en el proveedor',
  case_kind_provider_deleted: 'Borrada en el proveedor',
  col_case_kind: 'Tipo',
  col_case_status: 'Estado',
  col_case_organization: 'Organización',
  col_case_residual: 'Diferencia',
  col_case_runs: 'Corridas',
  col_case_hold: 'Retención',
  col_case_created: 'Abierto',
  hold_yes: 'Congelada',
  hold_no: 'Sin retención',
  cases_empty_title: 'Sin casos',
  cases_empty_description: 'No hay diferencias pendientes con estos filtros.',
  action_investigate: 'Marcar en revisión',
  action_resolve: 'Resolver',
  investigate_success: 'Caso marcado en revisión.',
  resolve_title: 'Resolver caso',
  resolve_description:
    'Vuelve a reconciliar antes de cerrar: si la diferencia sigue siendo grave, el caso no se resuelve.',
  resolve_type_label: 'Resolución',
  resolve_type_dismiss: 'Descartar (no era una diferencia real)',
  resolve_type_provider_corrected: 'El proveedor lo corrigió',
  resolve_note_label: 'Nota',
  resolve_note_placeholder: 'Qué encontraste y por qué se cierra',
  resolve_restore_label: 'Reactivar tarjetas',
  resolve_restore_description: 'Descongela las tarjetas que estaban activas antes de la retención.',
  resolve_confirm: 'Resolver',
  resolve_cancel: 'Cancelar',
  resolve_success: 'Caso resuelto.',

  calls_title: 'Llamadas al proveedor',
  calls_subtitle: 'Auditoría de cada llamada al proveedor de tarjetas, sin datos sensibles.',
  calls_operation_placeholder: 'Operación, p. ej. accounts.batchTransfer',
  filter_outcome_label: 'Resultado',
  filter_outcome_all: 'Todos los resultados',
  outcome_ok: 'OK',
  outcome_error: 'Error',
  col_call_operation: 'Operación',
  col_call_outcome: 'Resultado',
  col_call_organization: 'Organización',
  col_call_targets: 'Recursos',
  col_call_created: 'Fecha',
  calls_empty_title: 'Sin llamadas',
  calls_empty_description: 'No hay llamadas con estos filtros.',
};
